"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMaxPositionSize = void 0;
const big_1 = __importDefault(require("@swyftx/big"));
const types_1 = require("../types");
const calculateMaxPositionSize = (args) => {
    const { availableMargin, marketPrice, orderType, marketPrecision, maxMarketLeverage, maxMarketLots, } = args;
    if ([types_1.MarginOrderType.Limit, types_1.MarginOrderType.Stop].includes(orderType)) {
        return (0, big_1.default)(maxMarketLots).toFixed(marketPrecision, big_1.default.roundDown);
    }
    const maxPositionSize = (0, big_1.default)(availableMargin).times(maxMarketLeverage).div(marketPrice);
    return big_1.default.min((0, big_1.default)(maxMarketLots), maxPositionSize).toFixed(marketPrecision, big_1.default.roundDown);
};
exports.calculateMaxPositionSize = calculateMaxPositionSize;
//# sourceMappingURL=maxPositionSize.js.map